import { useEffect, useState, useCallback } from 'react';
import styles from './pmndp-enhanced.module.css';
import { pmndpAPI } from "../../../services/pmndp.api";
import { toast } from "react-toastify";
import TableLoader from "../../../components/Loader/TableLoader";
const DialysisHistory = ({ abhaNumber, onClose }) => {

    const [dialysisHistory, setDialysisHistory] = useState([]);
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(15); // Set your page size here
    const [totalItems, setTotalItems] = useState(0);

    const getDialysisHistory = useCallback(async () => {
        if (!abhaNumber) {
            toast.error("ABHA not linked");
            return;
        }

        setIsPageLoading(true);
        try {

            const payload = {
                abhaId: abhaNumber,
                page: page,
                pageSize: pageSize
            };

            const responseDialysisHistory = await pmndpAPI.getDialysisHistory(payload);

            if (responseDialysisHistory.success) {
                const historyData = responseDialysisHistory.data.dataGet;
                setTotalItems(historyData.length || 0);

                if (Array.isArray(historyData) && historyData.length > 0) {
                    setDialysisHistory(historyData);
                } else {
                    setDialysisHistory([]);
                    toast.info("No Dialysis History Found");
                }
            } else {
                setDialysisHistory([]);
                toast.error("Failed to fetch dialysis history");
            }
        } catch (error) {
            console.error('Error fetching dialysis history:', error);
            setDialysisHistory([]);
          //  toast.error("Error fetching dialysis history");
        } finally {
            setIsPageLoading(false);
        }
    }, [abhaNumber, page, pageSize]);

    useEffect(() => {
        getDialysisHistory();
    }, [getDialysisHistory]);

    // Pagination
    const totalPages = Math.ceil(totalItems / pageSize);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return (
        <>
            <section className={styles['pmndp-card']} style={{ marginLeft: 0, marginRight: 0 }}>

                <div className={styles['pmndp-header']}>
                    <div className={styles['pmndp-header-content']}>
                        <div className={styles['pmndp-header-left']}>
                            <div className={styles['pmndp-icon']}>
                                <img src={"/images/PMNDP-logo.png"} alt="" />
                            </div>
                            <h4 className={styles['pmndp-title']}>PMNDP Hemo Dialysis History</h4>
                        </div>
                        <div className={styles['pmndp-modal-close']} onClick={() => onClose()}>
                            <img src="/images/closing.svg" alt="Close" />
                        </div>
                    </div>
                </div>

                <div className={styles['pmndp-table-container']}>
                    <div className="table-responsive rounded">
                        <table className={`${styles['pmndp-table']} table table-bordered custom-striped table-hover`}>
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>Pre Weight</th>
                                    <th>Post Weight</th>
                                    <th>Pre Blood Pressure</th>
                                    <th>Post Blood Pressure</th>
                                    <th>Hemoglobin</th>
                                    <th>Dialysis Held On</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isPageLoading ? (
                                    <TableLoader />
                                ) : Array.isArray(dialysisHistory) && dialysisHistory.length > 0 ? (
                                    dialysisHistory.map((item, index) => {
                                        const serialNumber = index + 1;
                                        return (
                                            <tr key={serialNumber}>
                                                <td>{serialNumber}</td>
                                                <td>{item.pre_weight}</td>
                                                <td>{item.post_weight}</td>
                                                <td>{item.pre_blood_pressure}</td>
                                                <td>{item.post_blood_pressure}</td>
                                                <td>{item.hemoglobin}</td>
                                                <td>{
                                                    (() => {
                                                        try {
                                                            const dateValue = item.status === "Complete" ? item.created : item.appointment_date;
                                                            if (!dateValue) return 'N/A';
                                                            const date = new Date(dateValue);
                                                            if (isNaN(date.getTime())) return 'Invalid Date';
                                                            return new Intl.DateTimeFormat('en-CA').format(date);
                                                        } catch (error) {
                                                            console.error('Error formatting date:', error);
                                                            return 'Date Error';
                                                        }
                                                    })()
                                                }</td>
                                                <td>{item.status}</td>
                                            </tr>
                                        )
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center">No dialysis history data available.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    {/* Pagination Controls */}
                    <div className={styles['pmndp-pagination']}>
                        <button
                            className={styles['pmndp-pagination-btn']}
                            onClick={() => handlePageChange(1)}
                            disabled={page === 1 || isPageLoading}
                            title="First"
                        >
                            &#171;
                        </button>
                        <button
                            className={styles['pmndp-pagination-btn']}
                            onClick={() => handlePageChange(page - 1)}
                            disabled={page === 1 || isPageLoading}
                            title="Previous"
                        >
                            Previous
                        </button>
                        {/* Show page numbers with ellipsis for better UX */}
                        {page > 2 && totalPages > 4 && (
                            <span style={{ padding: '0 4px' }}>...</span>
                        )}
                        {Array.from({ length: totalPages }, (_, i) => i + 1)
                            .filter(i =>
                                i === 1 ||
                                i === totalPages ||
                                (i >= page - 1 && i <= page + 1)
                            )
                            .map(i => (
                                <button
                                    key={i}
                                    className={`${styles['pmndp-pagination-btn']} ${page === i ? styles['active'] : ''}`}
                                    onClick={() => handlePageChange(i)}
                                    disabled={page === i || isPageLoading}
                                >
                                    {i}
                                </button>
                            ))}
                        {page < totalPages - 1 && totalPages > 4 && (
                            <span style={{ padding: '0 4px' }}>...</span>
                        )}
                        <button
                            className={styles['pmndp-pagination-btn']}
                            onClick={() => handlePageChange(page + 1)}
                            disabled={page === totalPages || totalPages === 0 || isPageLoading}
                            title="Next"
                        >
                            Next
                        </button>
                        <button
                            className={styles['pmndp-pagination-btn']}
                            onClick={() => handlePageChange(totalPages)}
                            disabled={page === totalPages || totalPages === 0 || isPageLoading}
                            title="Last"
                        >
                            &#187;
                        </button>
                        <span className={styles['pmndp-pagination-info']}>
                            Page {page} of {totalPages}
                        </span>
                    </div>
                </div>

            </section >
        </>
    )
}

export default DialysisHistory;
